'use client';

import useSWR from 'swr';
import { onboardingApi } from '@/lib/api';
import type { OnboardingState } from '@/types/onboarding';
import { LONG_LIVED_SWR_OPTIONS, useAuthedFetcher } from './swrConfig';

export function useOnboardingState() {
  const authedFetch = useAuthedFetcher();

  return useSWR<OnboardingState>(
    ['onboarding-state'],
    () => authedFetch((token) => onboardingApi.getState(token)),
    LONG_LIVED_SWR_OPTIONS,
  );
}
